import { render } from "./diretorEditar.vue?vue&type=template&id=1efc9e57"
import script from "./diretorEditar.vue?vue&type=script&lang=js"
export * from "./diretorEditar.vue?vue&type=script&lang=js"

import "./diretorEditar.vue?vue&type=style&index=0&id=1efc9e57&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__